import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Header from "./Header";
import { normalize } from "common/lib/normalize";
import { getMda } from "common/services/mda.service";
import { useParams } from "react-router-dom";
import Widgets from "./Widgets";
import MDAPayments from "./MDAPayments";
import BreadCrumb from "Components/Common/BreadCrumb";

const ViewMDA = () => {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const { id: mdaId } = useParams();

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getMda(mdaId, {
        populate: ["createdby", "updatedby", "payments", "region"],
      });
      setData(normalize(response.data));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [mdaId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <React.Fragment>
      <div className="page-content">
        <BreadCrumb
          title="MDA Details"
          pageTitles={[
            {
              title: "Dashboard",
              link: "/",
            },
            { title: "MDAs", link: "/mdas" },
          ]}
          back
        />
        <Container fluid>
          <Row>
            <Header mda={data} fetchData={fetchData} loading={loading} />
          </Row>
          <Row>
            <Col xxl={12}>
              <Widgets />
              <MDAPayments mda={data} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewMDA;
